import {ComponentFactoryResolver, NgModule} from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { TreatyRoutes } from './orbitax-treaty.routes';
import { TreatyEffect } from './store/effects/treaty.effect';
import { StoreModule } from '@ngrx/store';
import { treatyReducer } from './store/reducers/treaty.reducer';
import { TreatyApiService } from './services/treaty.service';
import { TreatyDynamicComponentHelper } from './orbitax-treaty-dynamic-component-helper';
import { SharedModule } from '@shared/shared.module';
import { TreatyDocumentComponent } from './components/treaty-document/treaty-document.component';
import {TreatyListComponent} from './components/treaty-list/treaty-list.component';
import { TreatyPdfViewerComponent } from './components/treaty-pdf-viewer/treaty-pdf-viewer.component';
import {TreatyTypeComponent} from './components/treaty-type/treaty-type.component';
import { TreatyStatusComponent } from './components/treaty-status/treaty-status.component';
import { TreatyStatusViewerComponent } from './components/treaty-status-viewer/treaty-status-viewer.component';
import { TreatyRequestedJurisdictionComponent } from './components/treaty-requested-jurisdiction/treaty-requested-jurisdiction.component';
import { TreatyRequestingJurisdictionComponent } from './components/treaty-requesting-jurisdiction/treaty-requesting-jurisdiction.component';
import { TreatyDocumentSidebarComponent } from './components/treaty-document-sidebar/treaty-document-sidebar.component';
import { OffsetTopDirective } from './directives/offset-top.directive';
import { ScrollableDirective } from './directives/scrollable.directive';
import { TreatyNewsViewerComponent } from './components/treaty-news-viewer/treaty-news-viewer.component';
import { TreatyNewsComponent } from './components/treaty-news/treaty-news.component';
import { TreatySummaryComponent } from './components/treaty-summary/treaty-summary.component';
import { TreatyBepsCbcExchangeStatusComponent } from './components/treaty-beps-cbc-exchange-status/treaty-beps-cbc-exchange-status.component';
import { TreatyButtonCellComponentComponent } from './components/cell-components/treaty-button-cell-component/treaty-button-cell-component.component';
import { TreatyCbcReportsCellComponentComponent } from './components/cell-components/treaty-cbc-reports-cell-component/treaty-cbc-reports-cell-component/treaty-cbc-reports-cell-component.component';
import { FootnoteDialogComponent } from './components/dialog-components/footnote-dialog/footnote-dialog/footnote-dialog.component';
import { WithholdingTaxRatesComponent } from './components/withholding-tax-rates/withholding-tax-rates.component';
import { TreatyRateCellComponent } from './components/cell-components/rate-cell-components/treaty-rate-cell/treaty-rate-cell.component';
import { ProgressiveBlockDialogComponent } from './components/dialog-components/progressive-block-dialog/progressive-block-dialog/progressive-block-dialog.component';
import { WithholdingTaxFormsComponent } from './components/withholding-tax-forms/withholding-tax-forms.component';
import { PlatformToolTreatyCountryPairSelectorComponent } from './components/platform-tool-treaty-country-pair-selector/platform-tool-treaty-country-pair-selector.component';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {CommandService} from '@core/services/command.service';
import {SelectTreatyCountryPairHandler} from '@features/treaty/services/select-treaty-country-pair.handler';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import { PlatformToolTreatyDocumentWrapperContentComponent } from './components/platform-tool-treaty-document-wrapper-content/platform-tool-treaty-document-wrapper-content.component';
import {CreateTreatyDocumentContentToolLinkHandler} from '@features/treaty/services/create-treaty-document-content-tool-link.handler';
import { TreatyCountryPairSelectorComponent } from './components/treaty-country-pair-selector/treaty-country-pair-selector.component';
import { TreatyCountryPairSelectorDialogComponent } from './components/treaty-country-pair-selector-dialog/treaty-country-pair-selector-dialog.component';
import { PlatformToolCountryPairSelectorButtonComponent } from './components/platform-tool-country-pair-selector-button/platform-tool-country-pair-selector-button.component';
import { PlatformToolTreatyOtherDocumentWrapperContentComponent } from './components/platform-tool-treaty-other-document-wrapper-content/platform-tool-treaty-other-document-wrapper-content.component';
import {CreateTreatyOtherDocumentContentToolLinkHandler} from '@features/treaty/services/create-treaty-other-document-content-tool-link.handler';
import { PlatformToolTreatyOtherVersionButtonComponent } from './components/platform-tool-treaty-other-version-button/platform-tool-treaty-other-version-button.component';
import { PlatformToolTreatyOtherVersionPopupComponent } from './components/platform-tool-treaty-other-version-popup/platform-tool-treaty-other-version-popup.component';

@NgModule({
  declarations: [
    TreatyTypeComponent,
    TreatyListComponent,
    TreatyDocumentComponent,
    TreatyPdfViewerComponent,
    TreatyStatusComponent,
    TreatyStatusViewerComponent,
    TreatyRequestedJurisdictionComponent,
    TreatyRequestingJurisdictionComponent,
    TreatyDocumentSidebarComponent,
    OffsetTopDirective,
    ScrollableDirective,
    TreatyNewsViewerComponent,
    TreatyNewsComponent,
    TreatySummaryComponent,
    TreatyBepsCbcExchangeStatusComponent,
    TreatyButtonCellComponentComponent,
    TreatyCbcReportsCellComponentComponent,
    FootnoteDialogComponent,
    WithholdingTaxRatesComponent,
    TreatyRateCellComponent,
    ProgressiveBlockDialogComponent,
    WithholdingTaxFormsComponent,
    PlatformToolTreatyCountryPairSelectorComponent,
    PlatformToolTreatyDocumentWrapperContentComponent,
    TreatyCountryPairSelectorComponent,
    TreatyCountryPairSelectorDialogComponent,
    PlatformToolCountryPairSelectorButtonComponent,
    PlatformToolTreatyOtherDocumentWrapperContentComponent,
    PlatformToolTreatyOtherVersionButtonComponent,
    PlatformToolTreatyOtherVersionPopupComponent,
  ],

  imports: [
    RouterModule.forChild(TreatyRoutes), // routes
    EffectsModule.forFeature([TreatyEffect]),  // effects
    StoreModule.forFeature('treaty', treatyReducer), // reducer
    // Orbitax node module
    SharedModule,
  ],
  exports: [
    PlatformToolTreatyCountryPairSelectorComponent,
    PlatformToolTreatyDocumentWrapperContentComponent,
    PlatformToolTreatyOtherDocumentWrapperContentComponent
  ],
  providers: [TreatyApiService]
})
export class OrbitaxTreatyModule {
  constructor(
    private commandService: CommandService,
    private selectTreatyCountryPairHandler: SelectTreatyCountryPairHandler,
    private createTreatyDocumentContentToolLinkHandler: CreateTreatyDocumentContentToolLinkHandler,
    private createTreatyOtherDocumentContentToolLinkHandler: CreateTreatyOtherDocumentContentToolLinkHandler
  ) {
    TreatyDynamicComponentHelper.init();
    TreatyDynamicComponentHelper.register('SelectTreatyCountryPairHandler', selectTreatyCountryPairHandler);
    TreatyDynamicComponentHelper.register('CreateTreatyDocumentContentToolLinkHandler', createTreatyDocumentContentToolLinkHandler);
    TreatyDynamicComponentHelper.register('CreateTreatyOtherDocumentContentToolLinkHandler', createTreatyOtherDocumentContentToolLinkHandler);
    let command = new PlatformCommand('SelectTreatyCountryPairToolLinkCommand', Api.Treaty);
    this.commandService.registrPlatformLinkCommand('/treaties', command);

    command = new PlatformCommand('CreateTreatyDocumentContentToolLinkCommand', Api.Treaty);
    this.commandService.registrPlatformLinkCommand('/treaties/:countryOne/:countryTwo', command);

    command = new PlatformCommand('CreateTreatyDocumentContentToolLinkCommand', Api.Treaty);
    this.commandService.registrPlatformLinkCommand('/treaties/:countryOne/:countryTwo/:documentId', command);

    command = new PlatformCommand('CreateTreatyOtherDocumentContentToolLinkCommand', Api.Treaty);
    this.commandService.registrPlatformLinkCommand('/treaties/:documentId', command);
  }
}
